import { AddNewDoc, Locked, Signature } from '@vibe/icons';
import React from 'react';

const STEPS = [
  {
    icon: AddNewDoc,
    title: '1. Prepare Board Fields',
    description: (
      <>
        Add dynamic data tags and form fields within the{' '}
        <span style={{ fontWeight: 600, color: '#004690' }}>DOCX Editor</span>{' '}
        environment.
      </>
    ),
  },
  {
    icon: Locked,
    title: '2. Save Progress',
    description:
      'Lock in your structure and metadata to ensure data integrity before moving to the signing phase.',
  },
  {
    icon: Signature,
    title: '3. Configure Signatures',
    description: (
      <>
        Set signer order and placement within the{' '}
        <span style={{ fontWeight: 600, color: '#004690' }}>GetSign Editor</span>{' '}
        to finalize the document.
      </>
    ),
  },
];

export const WorkflowGuideStepContent: React.FC = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
    <h3
      style={{
        margin: '0 0 4px 0',
        fontSize: '18px',
        fontWeight: 600,
        color: '#323338',
        fontFamily: "'Figtree', sans-serif",
      }}
    >
      Workflow Guidance
    </h3>
    <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#676879' }}>
      Follow these steps to complete your document.
    </p>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {STEPS.map((step, index) => {
        const StepIcon = step.icon;
        const isLast = index === STEPS.length - 1;
        return (
          <div key={step.title} style={{ display: 'flex', gap: '16px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',
                  height: '44px',
                  flexShrink: 0,
                  borderRadius: '8px',
                  background: '#0073ea',
                  color: '#fff',
                }}
              >
                <StepIcon style={{ width: '20px', height: '20px' }} />
              </span>
              {!isLast && (
                <span
                  style={{
                    margin: '4px 0',
                    width: '1px',
                    flex: 1,
                    background: '#d0d4e4',
                  }}
                />
              )}
            </div>
            <div style={{ paddingBottom: isLast ? 0 : '20px' }}>
              <h3
                style={{
                  margin: '0 0 4px 0',
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#323338',
                }}
              >
                {step.title}
              </h3>
              <p style={{ margin: 0, fontSize: '13px', color: '#676879' }}>
                {step.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default WorkflowGuideStepContent;
